"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
require("./index.scss");
const react_helmet_1 = __importDefault(require("react-helmet"));
const mobx_react_1 = require("mobx-react");
const react_router_dom_1 = require("react-router-dom");
const HomeSceneWrapper_1 = __importDefault(require("@Components/HomeSceneWrapper"));
const TabsWrapperComponent_1 = __importDefault(require("@Components/TabsWrapperComponent"));
const MemberInternalScene_1 = __importDefault(require("@Scenes/HomeInternalScene/MemberInternalScene"));
const SongwriterInternalScene_1 = __importDefault(require("@Scenes/HomeInternalScene/SongwriterInternalScene"));
const HomeInternalScene = () => {
    const internalHomeTabs = [
        {
            tabName: 'Members',
            tabComponent: react_1.default.createElement(MemberInternalScene_1.default, null),
        },
        {
            tabName: 'Songwriters',
            tabComponent: react_1.default.createElement(SongwriterInternalScene_1.default, null),
        },
    ];
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_helmet_1.default, { title: 'Home' }),
        react_1.default.createElement(HomeSceneWrapper_1.default, { header: react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("h1", null, "Welcome to The MLC Admin Portal"),
                react_1.default.createElement("p", null, "It's time to Connect to Collect\u2122!")) },
            react_1.default.createElement("div", { className: 'release-notes-section' },
                react_1.default.createElement(react_router_dom_1.Link, { className: 'release-link', to: 'https://themlccom.sharepoint.com/sites/Portal/SitePages/Portal-Release-Notes-History.aspx', target: "_blank", rel: "noopener noreferrer" }, "Release Notes")),
            react_1.default.createElement(TabsWrapperComponent_1.default, { tabs: internalHomeTabs, defaultTab: internalHomeTabs[0], preventScrollReset: true }))));
};
exports.default = (0, mobx_react_1.observer)(HomeInternalScene);
